import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter, Link } from "react-router-dom";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";
import ReactOTable from "app/_L1_components/Elements/ReactOTable";
import ReactOModal from "app/_L1_components/Elements/ReactOModal";
import ReactOActionBar from "app/_L1_components/Elements/ReactOActionBar";

class UserManagement extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      loading_probes: false,
      data: null,
    };
    super(props, initState);
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    this._LOADING_ENABLED = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (
      !this.getAppContext().isCloud() ||
      this.getAppContext().authHandler.getAccountData().ExternalLogin == "no" ||
      this.getAppContext().authHandler.getAccountData().type != "ADMIN"
    ) {
      this.getAppContext().redirectTo("/web");
    }
    this.apiStore = this.getAppContext().getApiStoreService();
    this.getUsers();
  }

  onComponentWillUnmount() {}

  getUsers(cb, fast) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("get_user", {
          ___onSuccess: (status, data) => {
            this.setState({
              userData: data,
              loading: false,
            });
          },
        });
      }
    );
  }

  createUser(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("create_user", {
          data: data,
          ___onSuccess: (status, data) => {
            this.setState(
              {
                userData: data,
                loading: false,
              },
              () => {
                if (cb) cb(status, data);
              }
            );
          },
        });
      }
    );
  }
  editUser(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("edit_user", {
          data: data,
          ___onSuccess: (status, data) => {
            this.setState(
              {
                userData: data,
                loading: false,
              },
              () => {
                if (cb) cb(status, data);
              }
            );
          },
        });
      }
    );
  }

  deleteUser(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("delete_user", {
          data: {
            id_als: data.id_als,
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                userData: data,
                loading: false,
              },
              () => {
                if (cb) cb();
              }
            );
          },
        });
      }
    );
  }

  // TO DO: EDIT / SAVE LOGIN

  onRender() {
    return (
      <Section designType="narrow" className="mt-3">
        <_LoadingWrapper loadingPlug={this.state.loading && this._LOADING_ENABLED}>
          <div className="d-flex py-1">
            <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
              <div style={{ display: "inline-block" }}>
                <span className="icon-users" style={{ fontSize: "1.25rem" }}></span>
              </div>
              <div style={{ display: "inline-block" }}>
                <h5 className="ml-2">Login management</h5>
              </div>
            </div>
            <div className="ml-auto mt-3">
              <Link
                to={{
                  pathname: "/loginconf/grouplist",
                }}
                target="_blank"
              >
                <ReactOButton className="mr-2" outline color="secondary">
                  Group list
                </ReactOButton>
              </Link>
              <ReactOButton
                icon="user-plus"
                color="primary"
                disabled={this.state.loading}
                onClick={() => {
                  this._user_modal.open();
                }}
              >
                Add user
              </ReactOButton>
            </div>
          </div>
          <Panel bodyClassName="p-0" rounded>
            {this.state.userData ? (
              <div>
                <_LoadingWrapper loadingPlug={this.state.loading_probes}>
                  <ReactOTable
                    thClassName="px-3 py-1"
                    tdClassName="align-middle px-3 py-2"
                    compressed={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                    }
                    // compressedRowRendering={(row_items) => {
                    //   return (
                    //     <div>
                    //       <div className="mt-2">
                    //         <div className="text-muted">
                    //           <small className="">
                    //             <strong>{row_items.probes.title}</strong>
                    //           </small>
                    //         </div>
                    //         {row_items.probes.content}
                    //       </div>
                    //       <div className="mt-2">
                    //         <div className="text-muted">
                    //           <small className="">
                    //             <strong>{row_items.measures_conf.title}</strong>
                    //           </small>
                    //         </div>
                    //         {row_items.measures_conf.content}
                    //       </div>
                    //       <div className="mt-2">
                    //         <div className="text-muted">
                    //           <small className="">
                    //             <strong>{row_items.probe_status.title}</strong>
                    //           </small>
                    //         </div>
                    //         {row_items.probe_status.content}
                    //       </div>
                    //       <div className="mt-2">{row_items.ctrl.content}</div>
                    //     </div>
                    //   );
                    // }}
                    thDividers
                    cols={[
                      {
                        title: "User",
                        data_key: "user",
                        align: "center",
                        width: "40",
                        sortable: true,
                      },
                      {
                        title: "Group",
                        data_key: "group",
                        align: "center",
                        width: "20",
                        sortable: true,
                      },
                      {
                        title: "Permission",
                        data_key: "type",
                        align: "center",
                        width: "20",
                        sortable: true,
                      },
                      ...(this.getAppContext().authHandler.getAccountData().type ==
                      "ADMIN"
                        ? [
                            {
                              title: "",
                              data_key: "ctrl",
                              width: "15",
                              align: "center",
                            },
                          ]
                        : []),
                    ]}
                    rows={(() => {
                      let _TMP = [];
                      this.state.userData.users.forEach((_Curr, _Id) => {
                        _TMP.push({
                          user: {
                            value: _Curr.user,
                            render: (
                              <div>
                                <h5>{_Curr.user}</h5>
                                <span className="sub-title">{_Curr.email}</span>
                              </div>
                            ),
                          },
                          group: {
                            value: _Curr.group,
                            render: <span>{_Curr.group}</span>,
                          },
                          type: {
                            value: _Curr.type,
                            render: <span>{_Curr.type}</span>,
                          },
                          ...(this.getAppContext().authHandler.getAccountData().type ==
                            "ADMIN" && {
                            ctrl: (
                              <div className="d-flex align-items-center">
                                <ReactOActionBar align="center" padding="0">
                                  <ReactOButton
                                    title="Edit user"
                                    icon="pencil"
                                    color="gray200"
                                    size="sm"
                                    onClick={() => {
                                      this._user_modal.open(_Curr);
                                    }}
                                  />
                                  <ReactOButton
                                    className="ml-1 custom-danger-icon"
                                    title="Delete user"
                                    icon="cancel"
                                    color="gray200"
                                    size="sm"
                                    onClick={() => {
                                      this._user_deleting_modal.open(_Curr);
                                    }}
                                  />
                                </ReactOActionBar>
                              </div>
                            ),
                          }),
                        });
                      });
                      return _TMP;
                    })()}
                  />

                  <ReactOModal
                    modalId="userManagement"
                    size="md"
                    onControllerReady={(modal_context) => {
                      this._user_modal = modal_context;
                    }}
                    onModalMounted={(data) => {
                      this._user_form.init(data);
                    }}
                    header={(data) => (data ? "Edit user" : "Create user")}
                    centered={true}
                    body={(data) => {
                      return (
                        <div>
                          <ReactOForm
                            onControllerReady={(form_controller) => {
                              this._user_form = form_controller;
                            }}
                            onSubmit={(form_data, cb) => {
                              if (data) {
                                this.editUser(form_data, cb);
                              } else {
                                this.createUser(form_data, cb);
                              }
                            }}
                          >
                            <ReactOFormInput
                              type="hidden"
                              data_key="group"
                              default={(data && data.group) || ""}
                            />

                            <ReactOFormInput
                              className="mb-1"
                              type="text"
                              label="User"
                              disabled={data}
                              data_key="user"
                              placeholder="User"
                              size="md"
                              default={data && data.user}
                            />

                            <ReactOFormInput
                              className="mb-1"
                              type="text"
                              label="Email"
                              disabled={data}
                              data_key="email"
                              placeholder="Email"
                              size="md"
                              default={(data && data.email) || ""}
                              validators={
                                !data && [
                                  {
                                    func: (value) => {
                                      return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
                                        value
                                      );
                                    },
                                    invalid_text: "Type a valid email",
                                  },
                                ]
                              }
                            />

                            <ReactOFormInput
                              className="mt-3"
                              type="select"
                              data_key={"id_acc"}
                              label="Group"
                              forceFirstDefault
                              default={(data && data.id_acc) || ""}
                              options={() => {
                                return this.state.userData.groups.map((group) => {
                                  return {
                                    name: group.name,
                                    value: group.id_acc,
                                  };
                                });
                              }}
                              onOptionSelect={(form_ctrl, selected_value) => {
                                form_ctrl.handleFormChange(
                                  "group",
                                  this.state.userData.groups.filter((x) => {
                                    return x.id_acc == selected_value;
                                  })[0].name
                                );
                                form_ctrl.handleFormChange("id_acc", selected_value);
                              }}
                            />
                            <ReactOFormInput
                              className="mt-3"
                              type="select"
                              data_key={"type"}
                              label="Permission"
                              forceFirstDefault
                              default={(data && data.type) || ""}
                              options={() => {
                                return [
                                  { name: "ADMIN", value: "ADMIN" },
                                  { name: "USER", value: "USER" },
                                ];
                              }}
                            />
                          </ReactOForm>
                        </div>
                      );
                    }}
                    actions={[
                      {
                        text: "Cancel",
                        color: "light",
                        action: "close",
                      },

                      (data) => {
                        return {
                          text: data ? "Save" : "Create",
                          color: "primary",
                          action: () => {
                            this._user_form.submit((submit_result) => {
                              if (submit_result.status === true) {
                                this._user_modal.close();
                              }
                            });
                          },
                        };
                      },
                    ]}
                  />

                  <ReactOModal
                    modalId="user_deleting_modal"
                    size="md"
                    onControllerReady={(modal_context) => {
                      this._user_deleting_modal = modal_context;
                    }}
                    centered={true}
                    header={(data) => {
                      return <div>Delete user</div>;
                    }}
                    body={(data) => {
                      return (
                        <div>
                          Are you sure you want to delete user
                          <strong> {data.user}</strong>?
                        </div>
                      );
                    }}
                    actions={[
                      {
                        text: "Cancel",
                        color: "light",
                        action: "close",
                      },
                      (data) => {
                        return {
                          text: "Delete",
                          color: "danger",
                          icon: "delete",
                          action: () => {
                            this.deleteUser(data, () => {
                              this._user_deleting_modal.close();
                            });
                          },
                        };
                      },
                    ]}
                  />
                </_LoadingWrapper>
              </div>
            ) : null}
          </Panel>
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  withRouter(UserManagement),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  }
);
